type Listener = (active: boolean) => void;

const activeSources = new Set<string>();
const listeners = new Set<Listener>();

const notify = () => {
  const active = activeSources.size > 0;
  listeners.forEach((listener) => {
    try {
      listener(active);
    } catch {
      // Listener errors should not break overlay updates.
    }
  });
};

export const setAIGlowSourceActive = (sourceId: string, active: boolean) => {
  if (!sourceId) return;
  const hasSource = activeSources.has(sourceId);
  if (active && !hasSource) {
    activeSources.add(sourceId);
    notify();
    return;
  }
  if (!active && hasSource) {
    activeSources.delete(sourceId);
    notify();
  }
};

export const clearAIGlowSource = (sourceId: string) => {
  if (!sourceId) return;
  if (activeSources.delete(sourceId)) {
    notify();
  }
};

export const subscribeAIGlowOverlay = (listener: Listener) => {
  listeners.add(listener);
  listener(activeSources.size > 0);
  return () => {
    listeners.delete(listener);
  };
};

